import { COLLECTION_LIST_ITEM_COUNT, LABOREDITOR_HISTORY_LIST_COUNT } from '../../../settings.js'
import store from '../../../store'
import connector from '../../connector.js'

/**
 * Get collections list
 * @returns {import('../../../types').Collection[]}
 */
export async function getList() {
  return connector.get('core/collections').json()
}

export async function getListItems(collectionId, { search, offset, limit = COLLECTION_LIST_ITEM_COUNT }, options) {
  const searchParams = { collection: collectionId, limit, search, offset }
  return connector.get('core/collection-items', { searchParams, ...options, collection: collectionId }).json()
}

/**
 * Get collection
 * @param {number} collectionId Collection ID
 * @returns {import('../../../types').Collection}
 */
export async function getInstance(collectionId) {
  return connector.get(`core/collections/${collectionId}`).json()
}

/**
 *
 * @param {number} collectionId Collection ID to return items for
 */
export async function getCollectionItems(collectionId, { search, limit = 200 }) {
  return connector.get('core/collection-items', { searchParams: { collection: collectionId, search, limit } }).json()
}

/**
 *
 * @param {number} collectionId Collection ID to return items for
 * @param {number} itemId ID of the collection item
 */
export async function getCollectionItemInstance({ collectionId, collectionItemId }) {
  return connector.get(`core/collection-items/${collectionItemId}`, { searchParams: { collection: collectionId } }).json()
}

/**
 * Creates a new collection item inside the collection specified by collectionId
 * @param {number} collectionId Collection ID to return items for
 */
export async function createItem({ collectionId, fields }) {
  return connector.post('core/collection-items', fields, { searchParams: { collection: collectionId } }).json()
}

/**
 * Updates the given collection item
 * @param {number} collectionId Collection ID to return items for
 * @param {number} collectionItemId Collection Item ID to modify
 */
export async function updateItem({ collectionId, collectionItemId, fields }) {
  return connector.patch(`core/collection-items/${collectionItemId}`, fields, { searchParams: { collection: collectionId } }).json()
}

/**
 * Removes the given collection item
 * @param {number} collectionId Collection ID to return items for
 * @param {number} collectionItemId Collection Item ID to modify
 */
export async function removeItem({ collectionId, collectionItemId }) {
  return connector.delete(`core/collection-items/${collectionItemId}`, { searchParams: { collection: collectionId } }).json()
}

export const historyApi = {
  /**
   * Get deleted collection items
   * @param {string} id Analysis id
   */
  async getDeletedItems({ offset, limit = LABOREDITOR_HISTORY_LIST_COUNT, collection }) {
    const response = await connector.get(`laboreditor/history/collectionitem/deleted`, { searchParams: { offset, limit, collection } }).json()
    store.commit('laborEditor/deletedCollectionItems', response)
    return response
  },

  /**
   * Get deleted history for collection items
   * @param {string} id Analysis id
   */
  async getDeletedHistoryItems(id, { offset, limit = LABOREDITOR_HISTORY_LIST_COUNT, collection }) {
    const response = await connector.get(`laboreditor/history/collectionitem/deleted/${id}`, { searchParams: { offset, limit, collection } }).json()
    store.commit('laborEditor/historyCollectionItem', response)
    return response
  },

  /**
   * Get history for collection item
   * @param {string} id CollectionItem id
   */
  async getHistoryItems(id, { offset, limit = LABOREDITOR_HISTORY_LIST_COUNT }) {
    const response = await connector.get(`laboreditor/history/collectionitem/${id}`, { searchParams: { offset, limit } }).json()
    store.commit('laborEditor/historyCollectionItem', response)
    return response
  },

  /**
   * Get history item for collection item by id
   * @param {string} id CollectionItem id
   * @param {string} hid History item id
   */
  async getHistoryItem({ id, hid }) {
    const response = await connector.get(`laboreditor/history/collectionitem/${id}/${hid}`).json()
    return response
  },


  /**
   * Get history item for deleted collection item by id
   * @param {string} id Analysis id
   * @param {string} hid History item id
   */
  async getDeletedHistoryItem({ id, hid }) {
    const response = await connector.get(`laboreditor/history/collectionitem/deleted/${id}/${hid}`).json()
    return response
  },

  /**
   * Get history item for collection item by id
   * @param {string} id CollectionItem id
   * @param {string} hid History item id
   */
  async performRollback({ id, hid }) {
    const response = await connector.post(`laboreditor/history/collectionitem/${id}/${hid}/rollback`).json()
    return response
  }
}
